import Tokens from 'config/tokens'

import TableCell from '@mui/material/TableCell'

const TableHeadCell = ({ ...tableCellProps }) => (
  <TableCell sx={{ fontWeight: Tokens.font.weight.semiBold }} {...tableCellProps} />
)

export default TableHeadCell
